// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_UeL","cls2":"shared-cls2_ruD shared-cls1_UeL"};